import RecentArticlesCarousel from '../components/RecentArticlesCarousel';
import CMS_2UpImages from '../CMS/CMS-2UpImages';
import CMS_Blockquote from '../CMS/CMS-Blockquote';
import CMS_CollectionSlider from '../CMS/CMS-CollectionSlider';
import CMS_FeaturedProductReview from '../CMS/CMS-FeaturedProductReview';
import CMS_FlexibleColumns from '../CMS/CMS-FlexibleColumns';
import CMS_FullWidthImage from '../CMS/CMS-FullWidthImage';
import CMS_HeroBanner from '../CMS/CMS-HeroBanner';
import CMS_ImageSlider from '../CMS/CMS-ImageSlider';
import CMS_ProductSlider from '../CMS/CMS-ProductSlider';
import CMS_RelatedContent from '../CMS/CMS-RelatedContent';
import CMS_ShoppableImage from '../CMS/CMS-ShoppableImage';
import CMS_SplitContent from '../CMS/CMS-SplitContent';
import CMS_TextHeading from '../CMS/CMS-TextHeading';
import CMS_Video from '../CMS/CMS-Video';
import CMS_WysiwygContent from '../CMS/CMS-WysiwygContent';
import ArticleTileCustom from '../components/ArticleTileCustom';
import AuthorBlock from '../components/AuthorBlock';

RecentArticlesCarousel();
CMS_2UpImages();
CMS_Blockquote();
CMS_CollectionSlider();
CMS_FeaturedProductReview();
CMS_FlexibleColumns();
CMS_FullWidthImage();
CMS_HeroBanner();
CMS_ImageSlider();
CMS_ProductSlider();
CMS_RelatedContent();
CMS_ShoppableImage();
CMS_SplitContent();
CMS_TextHeading();
CMS_Video();
CMS_WysiwygContent();
ArticleTileCustom();
AuthorBlock();
